<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="card card-custom gutter-b bg-transparent shadow-none border-0"
                >
                  <div
                    class="card-header align-items-center border-bottom-dark px-0"
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Инвентаризация
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <form @submit.prevent="downloadInventoryPDF">
                <div class="row">
                  <div class="col-3 form-group">
                    <multiselect
                      v-model="warehouse"
                      :options="warehouses"
                      placeholder="Склад"
                      track-by="warehouse_id"
                      label="warehouse_name"
                      :allow-empty="true"
                      :show-labels="false"
                      :clear-on-select="false"
                      :close-on-select="true"
                      class=""
                    ></multiselect>
                  </div>
                  <div class="col-4 form-group">
                    <div class="form-check form-check-inline mb-2">
                      <input class="form-check-input" type="radio" id="byYear" v-model="mode" value="year">
                      <label class="form-check-label mr-3" for="byYear">По году</label>
                      <input class="form-check-input" type="radio" id="byDate" v-model="mode" value="date">
                      <label class="form-check-label" for="byDate">По дате</label>
                    </div>
                    <multiselect
                      v-if="mode === 'year'"
                      v-model="year"
                      :options="yearOptions"
                      placeholder="Год"
                      track-by="value"
                      label="label"
                      :allow-empty="false"
                      class=""
                    ></multiselect>
                    <input
                      v-if="mode === 'date'"
                      type="date"
                      v-model="inventoryDate"
                      class="form-control"
                      :max="maxDate"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-primary text-nowrap">Создать акт инвентаризации</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      warehouse: null,
      warehouses: [],
      mode: 'year',
      year: null,
      yearOptions: [],
      inventoryDate: new Date().toISOString().split('T')[0],
      maxDate: new Date().toISOString().split('T')[0],
    };
  },
  methods: {
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const yearOptions = [];
      for (let year = 2023; year <= currentYear + 1; year++) {
        yearOptions.push({ value: year, label: year.toString() });
      }
      return yearOptions;
    },
    fetchWarehouses() {
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      axios.get("/api/admin/warehouse?getAllData=1", config)
        .then((res) => {
          if (res.data.status === "Success") {
            this.warehouses = res.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    downloadInventoryPDF() {
      if (this.mode === 'year' && !this.year) {
        return;
      }
      if (this.mode === 'date' && !this.inventoryDate) {
        return;
      }

      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob'
      };
      const params = new URLSearchParams();
      if (this.mode === 'year') {
        params.append('year', this.year.value);
      } else {
        params.append('date', this.inventoryDate);
      }
      if (this.warehouse && this.warehouse.warehouse_id) {
        params.append("warehouse_id", this.warehouse.warehouse_id);
      }

      axios.get("/api/admin/stock/inventory?" + params.toString(), config)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          let fileName;
          if (this.mode === 'year') {
            fileName = this.warehouse
              ? 'Inventory_Report_' + this.year.value + '_' + this.warehouse.warehouse_name + '.pdf'
              : 'Inventory_Report_' + this.year.value + '_all_warehouses.pdf';
          } else {
            const formattedDate = this.inventoryDate.replace(/-/g, '_');
            fileName = this.warehouse
              ? 'Inventory_Report_' + formattedDate + '_' + this.warehouse.warehouse_name + '.pdf'
              : 'Inventory_Report_' + formattedDate + '_all_warehouses.pdf';
          }
          link.download = fileName;
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          console.error(error);
        });
    },
  },
  mounted() {
    this.yearOptions = this.generateYearOptions();
    this.year = this.yearOptions[this.yearOptions.length - 2];
    this.fetchWarehouses();
  },
};
</script>
